<template>
  <div>
    <md-toolbar md-elevation="0" class="md-transparent" style="background: white!important;height: 52px;">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h5>{{ $t($route.name) }}</h5>
        </div>
        <div class="md-toolbar-section-end">
          <input
            id="filter-input"
            class="indexinput"
            v-model="filter"
            type="search"
            :placeholder="$t('Қидирув')"
          >
        <button v-if="rule.open==true"  class="btn btn-primary mybtn insertbutton" @click="Href('/refundsuplier/create')" >
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
        </button>
        <button class="btn btn-primary mybtn" type="button" @click="Data()">
          <b-icon icon="arrow-repeat"></b-icon>
        </button>
        <top></top>
        </div>
      </div>
    </md-toolbar>
    <b-container fluid>
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="$store.state.countindex"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"      
      @row-dblclicked="Update"
      :filter-function="filterFunction"
    >
      <template #cell(sklad)="row">
        <span v-if="row.item.sklad != null">
          {{ row.item.sklad.name }}
        </span>
      </template>
      <template #cell(kontragent)="row">
        <span v-if="row.item.kontragent != null">
          {{ row.item.kontragent.name }}
        </span>
      </template>
      <template #cell(count_all)="row">
        {{ row.item.count_all | numFormat }}
      </template>
      <template #cell(summa)="row">
        {{ row.item.summa | numFormat }}
      </template>
      <template #cell(actions)="row" v-if="rule.change==true">
        <router-link
          class="circul pencil"
          :to="{ path: '/refundsuplier/update/' + row.item.id }"
        >
          <b-icon icon="pencil"></b-icon>
        </router-link>
        <a
          class="circul trash"
          href="javascript:void(0)"
          @click="Trash(row.item.id)"
        >
          <b-icon icon="trash"></b-icon>
        </a>
      </template>
    </b-table>
    <div class="bottomindex">
          <span>
            {{totalRows+' '+$t('ta listdan')+' '}}<span v-if="$store.state.countindex<totalRows">{{$store.state.countindex}}</span><span v-else>{{totalRows}}</span>{{$t('tasi')}}
          </span>
          <span v-if="totalRows > $store.state.countindex" style="padding:0 10px">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="$store.state.countindex"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </span>
      </div>
    </b-container>
  </div>
</template>
<script>
  import Top from "../Layout/Top.vue";
import { print } from "../../components/mixins/print.js";
import filterFunction from "../../utils/filterFunction";
export default {
components: {Top},
  mixins: [print],
  data() {
    return {
      items: [],
      errors: "",
      fields: [
        {
          key: "number",
          label: "Факт №",
          sortable: true,
          class: "text-center column1-5"
        },
        {
          key: "created_at",
          label: "Вақт",
          sortable: true,
          formatter: (value, key, item) => {
            return this.$formatDate(value);
          },
          sortByFormatted: true,
          filterByFormatted: true,
          class: "text-center column4"
        },
        { key: "sklad", label: "Cклад", sortable: true, class: "text-center" },
        {
          key: "summa",
          label: "Сумма",
          sortable: true,
          class: "text-center column2"
        },
        {
          key: "count_all",
          label: "Сони",
          sortable: true,
          class: "text-center column2"
        },

        {
          key: "kontragent",
          label: this.$t("Етказувчи"),
          sortable: true,
          class: "text-center"
        },
        {
          key: "user_id",
          label: this.$t("Фойдаланувчи"),
          sortable: true,
          class: "text-center column2-5",
          formatter: (value, key, item) => {
            if(item.user!=null){
              return item.user.first_name;
            }else{
              return "";
            }
          },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "actions", label: "", class: "column2" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    this.Data();
    // this.Interval();
  },
  methods: {
    filterFunction,
    Update(record, index) {
      if(this.rule.open==true){
      this.$router.push({ path: '/refundsuplier/update/' + record.id});
      }
    },
    Data() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/refund-supplier"
      }).then(function(response) {
        self.items = response.data;
        self.totalRows = self.items.length;
      });
    },
    Interval() {
      window.setInterval(() => {
        this.Data();
      }, 60000);
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Trash(id) {
      let self=this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
            method: "delete",
            url: "api/v1/refund-supplier/id/" + id
          }).then(function(response) {
            self.Data();
          });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        .catch(function() {});
    }
  }
};
</script>
